export const textStyles = {
  h1: {
    fontSize: ["5xl", "5xl", "6xl"],
    fontWeight: "bold",
    lineHeight: ["1.25", "1.25", "1.2"],
    letterSpacing: "-0.01em",
    color: "fg.default",
  },
  h2: {
    fontSize: ["5xl"],
    fontWeight: "bold",
    lineHeight: "1.25",
    letterSpacing: "-0.01em",
    color: "fg.default",
  },
  h3: {
    fontSize: ["3xl"],
    fontWeight: "bold",
    lineHeight: "1.17",
    letterSpacing: "-0.01em",
    color: "fg.default",
  },
  h4: {
    fontSize: ["2xl"],
    fontWeight: "bold",
    lineHeight: "1.2",
    letterSpacing: "-0.01em",
    color: "fg.default",
  },
  subtitle1: {
    fontSize: ["3xl"],
    fontWeight: "medium",
    lineHeight: "1.33",
    letterSpacing: "-0.01em",
  },
  subtitle2: {
    fontSize: ["2xl"],
    fontWeight: "medium",
    lineHeight: "1.4",
    letterSpacing: "-0.01em",
  },
  subtitle2SemiBold: {
    fontSize: ["2xl"],
    fontWeight: "semibold",
    lineHeight: "1.4",
    letterSpacing: "-0.01em",
  },
  subtitle3: {
    fontSize: ["xl"],
    fontWeight: "medium",
    lineHeight: "1.5",
    letterSpacing: "-0.01em",
    color: "fg.emphasized",
  },
  subtitle3SemiBold: {
    fontSize: ["xl"],
    fontWeight: "semibold",
    lineHeight: "1.5",
    letterSpacing: "-0.01em",
  },
  subtitle3Bold: {
    fontSize: ["xl"],
    fontWeight: "bold",
    lineHeight: "1.5",
    letterSpacing: "-0.01em",
  },
  subtitle4: {
    fontSize: ["lg"],
    fontWeight: "medium",
    lineHeight: "1.5",
    letterSpacing: "-0.01em",
  },
  subtitle4SemiBold: {
    fontSize: ["lg"],
    fontWeight: "semibold",
    lineHeight: "1.5",
    letterSpacing: "-0.01em",
  },
  subtitle4Bold: {
    fontSize: ["lg"],
    fontWeight: "bold",
    lineHeight: "1.5",
    letterSpacing: "-0.01em",
  },
  base: {
    fontSize: ["md"],
    fontWeight: "medium",
    lineHeight: "1.43",
    letterSpacing: "-0.01em",
    color: "fg.default",
  },
  baseBold: {
    fontSize: ["md"],
    fontWeight: "bold",
    lineHeight: "1.43",
    letterSpacing: "-0.01em",
  },
  codeL: {
    fontFamily: "mono",
    fontSize: ["lg"],
    lineHeight: "1.5",
    letterSpacing: "-0.01em",
    fontVariantLigatures: "none",
  },
  codeS: {
    fontFamily: "mono",
    fontSize: ["md"],
    lineHeight: "1.43",
    letterSpacing: "-0.01em",
    fontVariantLigatures: "none",
  },
  codeSHighlight: {
    fontFamily: "mono",
    fontSize: ["md"],
    lineHeight: "1.43",
    letterSpacing: "-0.01em",
    color: "fg.default",
    background: "highlight.subtle",
    padding: "0px 4px",
    borderRadius: "3px",
    fontVariantLigatures: "none",
  },
  buttonL: {
    fontSize: ["lg"],
    fontWeight: "medium",
    lineHeight: "1.5",
    letterSpacing: "-0.01em",
  },
  buttonM: {
    fontSize: ["md"],
    fontWeight: "medium",
    lineHeight: "1.43",
    letterSpacing: "-0.01em",
  },
  buttonLinkL: {
    fontSize: ["lg"],
    fontWeight: "medium",
    lineHeight: "1.5",
    letterSpacing: "-0.01em",
    textDecorationLine: "underline",
  },
  buttonLinkM: {
    fontSize: ["md"],
    fontWeight: "medium",
    lineHeight: "1.43",
    letterSpacing: "-0.01em",
    textDecorationLine: "underline",
  },
  caption: {
    fontSize: ["sm"],
    fontWeight: "medium",
    lineHeight: "1.5",
    letterSpacing: "-0.01em",
  },
  captionLink: {
    fontSize: ["sm"],
    fontWeight: "medium",
    lineHeight: "1.5",
    letterSpacing: "-0.01em",
    textDecorationLine: "underline",
  },
  captionBold: {
    fontSize: ["sm"],
    fontWeight: "bold",
    lineHeight: "1.5",
    letterSpacing: "-0.01em",
  },
  captionCode: {
    fontFamily: "mono",
    fontSize: ["xs"],
    fontWeight: "normal",
    lineHeight: "1.6",
    letterSpacing: "-0.01em",
    fontVariantLigatures: "none",
  },
  label: {
    fontSize: ["xs"],
    fontWeight: "medium",
    lineHeight: "1.6",
    letterSpacing: "-0.01em",
  },
  dashed: {
    borderBottom: "1px dashed",
    borderBottomColor: "currentColor",
  },

  future: {
    body: {
      sm: {
        fontFamily: "body",
        fontSize: "future.sm",
      },
    },
  },
};
